import { type ReactNode } from "react";
import { Breadcrumbs, type BreadcrumbItem } from "./Breadcrumbs";
import { Footer } from "./Footer";
import { Header } from "./Header";

interface PageLayoutProps {
    title?: string;
    children: ReactNode;
    showHeader?: boolean;
    showFooter?: boolean;
    headerVariant?: "auth" | "main";
    breadcrumbs?: BreadcrumbItem[];
}

export function PageLayout({
    title,
    children,
    showHeader = true,
    showFooter = true,
    headerVariant = "main",
    breadcrumbs,
}: PageLayoutProps) {
    return (
        <div className="min-h-screen page-gradient flex flex-col">
            {showHeader && <Header title={title} variant={headerVariant} />}

            {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}

            <div className="flex-1 pb-bottom-nav md:mb-8">{children}</div>

            {showFooter && <Footer />}
        </div>
    );
}
